const BUSCANDO = (state, payload) => {
    state.buscando = payload
  }
  
  const INSERIR_LISTA_USUARIOS = (state, payload) => {
    state.items = payload
  }
  
  const INSERIR_USUARIO = (state,  payload) => {
    state.items.push(payload)
  }
  
  const INSERIR_USUARIO_SELECIONADO = (state,  payload) => {
    state.selecionado = payload
  }
  
  const ATUALIZAR_USUARIO = (state, payload) => {
    state.items = state.items.map(usuario => {
      if(usuario.id === payload.id) {
        return payload;
      }
      return usuario
    })
  }
  
  const DELETAR_USUARIO = (state, payload) => {
    state.items = state.items.filter(usuario => usuario.id !== payload.id)
  }

  const INSERIR_LISTA_GRUPOS = (state, payload) => {
    state.grupos = payload
  }
  
  export {
    BUSCANDO,
    INSERIR_LISTA_USUARIOS,
    INSERIR_USUARIO,
    INSERIR_USUARIO_SELECIONADO,
    ATUALIZAR_USUARIO,
    DELETAR_USUARIO,
    INSERIR_LISTA_GRUPOS
  }